import React from 'react';
import PropTypes from 'prop-types';
import StyledLabel from '../styled-label';
import IconFactory from '../icons/factory-builder';

const namespace = 'vehicle-reservation';

const VehicleReservationLegacy = ({ title, values }) => (
  <div className={namespace}>
    <div className={`${namespace}__title-container`}>
      {IconFactory(title?.icon)}
      <StyledLabel className={`${namespace}__title`} {...title?.label} as="span" />
    </div>
    <ul className={`${namespace}__values`} color="primary" size="m">
      {values?.benefits.map(item => (
        <li key={item}>
          <StyledLabel className={`${namespace}__label`} as="span">
            {item.text}
          </StyledLabel>
        </li>
      ))}
    </ul>
  </div>
);

VehicleReservationLegacy.propTypes = {
  title: PropTypes.shape({
    label: PropTypes.shape({
      text: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      font_size: PropTypes.string.isRequired,
    }).isRequired,
    icon: PropTypes.shape({
      id: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
    }),
  }).isRequired,

  values: PropTypes.shape({
    benefits: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default React.memo(VehicleReservationLegacy);
